const EnterBar = () => import(/* webpackChunkName:"chunk-actbar" */ '../views/P5_Activitys/ActEnterBar/index.vue')

const BeerAct = () => import(/* webpackChunkName:"chunk-beeract" */ '../views/P5_Activitys/BeerCollect')

const CallMotivation = () => import(/* webpackChunkName:"chunk-callmotivation" */ '../views/P5_Activitys/CallMotivation/index.vue')
const CallMotivationRules = () => import(/* webpackChunkName:"chunk-callmotivation" */ '../views/P5_Activitys/CallMotivation/rules.vue')

// 动态页面容器
const DyPage = () => import(/* webpackChunkName:"chunk-dypage" */ '../views/P5_Activitys/DyPage/index.vue')

const EidAlAdhaMainFemale = () => import(/* webpackChunkName:"chunk-eidaladha" */ '../views/P5_Activitys/EidAlAdha/actFemaleMain.vue')
const EidAlAdhaRankFemale = () => import(/* webpackChunkName:"chunk-eidaladha" */ '../views/P5_Activitys/EidAlAdha/actFemaleRank.vue')
const EidAlAdhaRulesFemale = () => import(/* webpackChunkName:"chunk-eidaladha" */ '../views/P5_Activitys/EidAlAdha/actFemaleRules.vue')
const EidAlAdhaMainMale = () => import(/* webpackChunkName:"chunk-eidaladha" */ '../views/P5_Activitys/EidAlAdha/actMaleMain.vue')
const EidAlAdhaRankMale = () => import(/* webpackChunkName:"chunk-eidaladha" */ '../views/P5_Activitys/EidAlAdha/actMaleRank.vue')
const EidAlAdhaRecordsMale = () => import(/* webpackChunkName:"chunk-eidaladha" */ '../views/P5_Activitys/EidAlAdha/actMaleRecords.vue')
const EidAlAdhaRulesMale = () => import(/* webpackChunkName:"chunk-eidaladha" */ '../views/P5_Activitys/EidAlAdha/actMaleRules.vue')

const Incentive = () => import(/* webpackChunkName:"chunk-incentive" */ '../views/P5_Activitys/Incentive/index.vue')
const IncentiveForNew = () => import(/* webpackChunkName:"chunk-incentivefornew" */ '../views/P5_Activitys/IncentiveForNew/index.vue')

const Liveness = () => import(/* webpackChunkName:"chunk-liveness" */ '../views/P5_Activitys/Liveness/index.vue')
const LivenessRules = () => import(/* webpackChunkName:"chunk-liveness" */ '../views/P5_Activitys/Liveness/rules.vue')

const MatchingToPay = () => import(/* webpackChunkName:"chunk-matchingtopay" */ '../views/P5_Activitys/MatchingToPay/index.vue')

const MayDay2026MainMale = () => import(/* webpackChunkName:"chunk-mayday2026" */ '../views/P5_Activitys/MayDay2026/actMaleMain.vue')
const MayDay2026RecordsMale = () => import(/* webpackChunkName:"chunk-mayday2026" */ '../views/P5_Activitys/MayDay2026/actMaleRecords.vue')
const MayDay2026RulesMale = () => import(/* webpackChunkName:"chunk-mayday2026" */ '../views/P5_Activitys/MayDay2026/actMaleRules.vue')

const NewguyWheelPan = () => import(/* webpackChunkName:"chunk-NewguyWheelPan" */ '../views/P5_Activitys/NewguyWheelPan/index.vue')
const NewguyWheelPanRules = () => import(/* webpackChunkName:"chunk-NewguyWheelPan" */ '../views/P5_Activitys/NewguyWheelPan/rules.vue')

const NineDotNinetyNine = () => import(/* webpackChunkName:"chunk-NineDotNinetyNine" */ '../views/P5_Activitys/NineDotNinetyNine/index.vue')

const NineteenDotNinetyNine = () => import(/* webpackChunkName:"chunk-NineteenDotNinetyNine" */ '../views/P5_Activitys/NineteenDotNinetyNine/index.vue')

const PrivateCallIncome = () => import(/* webpackChunkName:"chunk-privatecall" */ '../views/P5_Activitys/PrivateCallIncome')

const RechargeAfterFirst = () => import(/* webpackChunkName:"chunk-rechargeAfterFirst" */ '../views/P5_Activitys/RechargeAfterFirst/index.vue')

const RechargeFirst = () => import(/* webpackChunkName:"chunk-rechargefirst" */ '../views/P5_Activitys/RechargeFirst/index.vue')

const RechargeLowSmall = () => import(/* webpackChunkName:"chunk-rechargeLowSmall" */ '../views/P5_Activitys/RechargeLowSmall/index.vue')

const RechargeMidR = () => import(/* webpackChunkName:"chunk-rechargeMidR" */ '../views/P5_Activitys/RechargeRUser/midR.vue')
const RechargeTopR = () => import(/* webpackChunkName:"chunk-rechargeTopR" */ '../views/P5_Activitys/RechargeRUser/topR.vue')

const Repurchase = () => import(/* webpackChunkName:"chunk-repurchase" */ '../views/P5_Activitys/Repurchase/index.vue')

const SayHi = () => import(/* webpackChunkName:"chunk-sayhi" */ '../views/P5_Activitys/SayHi/index.vue')

const routes = [
  // 运营位
  {
    path: '/act-enter', name: 'act-enter', component: EnterBar
  },
  // 啤酒收集节
  {
    path: '/beer-collect', name: 'beer-collect', component: BeerAct
  },
  // 男用户通话激励
  {
    path: '/call-motivation', name: 'call-motivation', component: CallMotivation
  },
  {
    path: '/call-motivation-rules', name: 'call-motivation-rules', component: CallMotivationRules
  },

  // 自定义图片页面
  {
    path: '/dy-page/:customPageId', name: 'dy-page', component: DyPage
  },
  // 宰牲节 / 古尔邦节活动
  {
    path: '/eidaladha-main-female', name: 'eidaladha-main-female', component: EidAlAdhaMainFemale
  },
  {
    path: '/eidaladha-rank-female', name: 'eidaladha-rank-female', component: EidAlAdhaRankFemale
  },
  {
    path: '/eidaladha-rules-female', name: 'eidaladha-rules-female', component: EidAlAdhaRulesFemale
  },
  {
    path: '/eidaladha-main-male', name: 'eidaladha-main-male', component: EidAlAdhaMainMale
  },
  {
    path: '/eidaladha-rank-male', name: 'eidaladha-rank-male', component: EidAlAdhaRankMale
  },
  {
    path: '/eidaladha-records-male', name: 'eidaladha-records-male', component: EidAlAdhaRecordsMale
  },
  {
    path: '/eidaladha-rules-male', name: 'eidaladha-rules-male', component: EidAlAdhaRulesMale
  },
  // 激励活动
  {
    path: '/incentive-act', name: 'incentive-act', component: Incentive
  },
  // 新用户激励活动
  {
    path: '/incentive-fornew', name: 'incentive-fornew', component: IncentiveForNew
  },
  // 升级奖励
  {
    path: '/liveness', name: 'liveness', component: Liveness
  },
  {
    path: '/liveness-rules', name: 'liveness-rules', component: LivenessRules
  },
  // match
  {
    path: '/matching-to-pay', name: 'matching-to-pay', component: MatchingToPay
  },
  // 五一活动（男用户）
  {
    path: '/mayday2026-main-male', name: 'mayday2026-main-male', component: MayDay2026MainMale
  },
  {
    path: '/mayday2026-records-male', name: 'mayday2026-records-male', component: MayDay2026RecordsMale
  },
  {
    path: '/mayday2026-rules-male', name: 'mayday2026-rules-male', component: MayDay2026RulesMale
  },
  // 新用户转盘
  {
    path: '/newguy-wheel-pan', name: 'newguy-wheel-pan', component: NewguyWheelPan
  },
  {
    path: '/newguy-wheel-pan-rules', name: 'newguy-wheel-pan-rules', component: NewguyWheelPanRules
  },
  // 充值活动9.99
  {
    path: '/recharge-ninepointninety', name: 'nine-dot-ninetynine', component: NineDotNinetyNine
  },
  // 充值活动19.99
  {
    path: '/nineteen-ninety_nine', name: 'nineteen-dot-ninetynine', component: NineteenDotNinetyNine
  },
  // 主播限时付费电话补贴
  {
    path: '/private-call-income', name: 'private-call-income', component: PrivateCallIncome
  },
  // 充值-次充
  {
    path: '/recharge-afterfirst', name: 'recharge-afterfirst', component: RechargeAfterFirst
  },
  // 充值-首充
  {
    path: '/recharge-first', name: 'recharge-first', component: RechargeFirst
  },
  // 低频小额用户充值
  {
    path: '/recharge-low-small', name: 'recharge-low-small', component: RechargeLowSmall
  },
  // 中小R用户充值
  {
    path: '/recharge-mid-r', name: 'recharge-mid-r', component: RechargeMidR
  },
  // 大R用户充值
  {
    path: '/recharge-top-r', name: 'recharge-top-r', component: RechargeTopR
  },
  // 复购
  {
    path: '/repurchase', name: 'repurchase', component: Repurchase
  },
  // SayHi
  {
    path: '/say-hi', name: 'say-hi', component: SayHi
  }
]
export default routes
